import { alpha, ListItem, ListItemButton, ListItemIcon, ListItemText, Theme } from "@mui/material";
import React from "react";

interface MenuListItemProps {
  open: boolean;
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  primaryText: string;
  secondaryText?: string;
  onClick?: () => void;
  showText?: boolean;
  additionalSx?: any;
}

export default function MenuListItem({ open, icon, rightIcon, primaryText, secondaryText, onClick, showText = true, additionalSx }: MenuListItemProps) {
  return (
    <ListItem disablePadding sx={{ display: "block", ...additionalSx }}>
      <ListItemButton
        onClick={onClick}
        sx={[
          {
            minHeight: 48,
            px: 2.5,
          },
          open
            ? {
                justifyContent: "initial",
              }
            : {
                justifyContent: "center",
              },
          {
            "&:hover": {
              backgroundColor: (theme: Theme) =>
                theme.palette.mode === "light" ? alpha(theme.palette.primary.main, 0.08) : alpha(theme.palette.primary.light, 0.12),
            },
          },
        ]}
      >
        {icon && (
          <ListItemIcon
            sx={[
              {
                minWidth: 0,
                justifyContent: "center",
              },
              open
                ? {
                    mr: 3,
                  }
                : {
                    mr: "auto",
                  },
            ]}
          >
            {icon}
          </ListItemIcon>
        )}
        {showText && (
          <ListItemText
            primary={primaryText}
            secondary={secondaryText}
            sx={[
              open
                ? {
                    opacity: 1,
                  }
                : {
                    opacity: 0,
                  },
            ]}
          />
        )}
        {rightIcon && open && (
          <ListItemIcon
            sx={{
              minWidth: 0,
              justifyContent: "center",
              ml: "auto",
            }}
          >
            {rightIcon}
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}
